import { FamilyIcon } from '@repo/ui/icons'

import UserNavBar from '../../../components/elements/nav-bar'
import OlCoachCompanyListPage from '../../../components/pages/ols/coach-companies/coach-company-list'

const OLCoachCompaniesGlobalListPage = () => {
  return (
    <div>
      <UserNavBar title={'Coach Companies'} icon={FamilyIcon} />
      <div className="h-4" />
      <OlCoachCompanyListPage mode="global" />
    </div>
  )
}

export default OLCoachCompaniesGlobalListPage
